
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58.142 58.142"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 680","d":"M55.997 26.925h-24.78V2.147a2.146 2.146 0 10-4.292 0v24.778H2.147a2.147 2.147 0 100 4.293h24.778v24.778a2.146 2.146 0 004.292 0V31.218h24.78a2.147 2.147 0 000-4.293z"}})])
          )
        }
      }
    